export const ALL_ROLES = -2;
export const NO_ROLE = -1;
